// frontend/src/components/ProtectedRoute.jsx
// Updated to use AuthContext instead of getToken() for httpOnly cookie auth
// Phase 4: adds onboarding hard-gate redirect (backend-truth-driven)
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { isAuthenticated, loading, user } = useAuth();
  const location = useLocation();

  // Show nothing while checking auth status or user object not yet loaded
  if (loading || !user) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  // If not authenticated, send user to the login page
  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // Onboarding hard gate — redirect to /onboarding if backend says blocked.
  // /onboarding is outside ProtectedRoute in App.jsx, so no loop is possible.
  if (user.onboarding?.isHardGateBlocked) {
    return <Navigate to="/onboarding" replace />;
  }

  // If authenticated and not blocked, allow access to the protected page
  return children;
}
